import React, { useState, useEffect } from 'react';
import StockSlider from './stockSlider/StockSlider';
import stockLiteListStyle from './stockLiteListStyle';
import { Typography, Box } from '@material-ui/core';
import Translation from '../../../gqlCommon/components/translation/Translation';
import clsx from 'clsx';
import useStockCars from '../../hooks/stockLite/useStockCars';
import scrollInView from '../../../common/service/scrollInView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TransferModalContainer from '../../../gqlStock/components/transferModal/TransferModalContainer';
import { useTransfer } from '../../hooks/stockLite/useTransfer';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { StockVersionTypes } from '../../../gqlCommon/enum/StockVersionTypes';
import { CustomiseSections } from '../../../common/enum/CustomiseSections';
import useCustomizeCarContext from '../../hooks/useCustomizeCarContext';

const StockLiteList = () => {
  const [showIcon, setShowIcon] = useState(true);
  const styles = stockLiteListStyle();
  const { loading, selectedCar } = useCustomizeCarContext();
  const carName = selectedCar?.car?.attributes?.vehicleDisplayName ?? '';
  const [carImageUrl, setCarImageUrl] = useState<string>('');
  const elements = useStockCars();
  const scrollToId = 'stockSlider_scrollTo';
  const scrollToElement = document.getElementById(scrollToId);
  const { isModalOpen, nextStockData, handleToggleModal, handleOnAcceptTransfer, handleTransferModalSelect } =
    useTransfer();

  const {
    platformConfig: { stockVersion },
  } = usePlatformConfig();

  useEffect(() => {
    if (nextStockData && nextStockData[0].images.length) {
      setCarImageUrl(nextStockData[0].images[0].url);
    }
  }, [nextStockData]);

  useEffect(() => {
    const onScroll = () => {
      const isSliderInView = scrollToElement && scrollInView.isInView(scrollToElement);
      setShowIcon(!isSliderInView);
    };
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollToElement]);

  if (!elements.length) {
    return null;
  }

  return (
    <Box id={CustomiseSections.STOCK} className={styles.container}>
      <Box>
        <Box data-test="stockLite:view:icon" className={styles.iconWrapper}>
          <ExpandMoreIcon className={clsx([styles.icon, { [styles.visible]: showIcon }])} />
        </Box>
      </Box>
      <Box className={styles.sectionWrapper}>
        <Typography variant="h4" className={styles.title}>
          <Translation id="trans__configurator__stock_section__section_title" data-test="stockLite:title" />
        </Typography>
        <StockSlider loading={loading} elements={elements} handleSelected={handleTransferModalSelect} />
        {stockVersion === StockVersionTypes.FULL && (
          <TransferModalContainer
            loading={loading}
            currentModel={carName}
            isModalOpen={isModalOpen}
            toggleModal={handleToggleModal}
            carImageUrl={carImageUrl}
            onAcceptTransfer={handleOnAcceptTransfer}
            onDeclineTransfer={handleToggleModal}
          />
        )}
        <Box id={scrollToId} />
      </Box>
    </Box>
  );
};

export default StockLiteList;
